import { useCallback } from 'react';

import { useOrientation } from '../../../../boot/OrientationContext';
import { GET_LAYOUT_MAX_WIDTH } from '../../../../constants/layout';
import { useTranslation } from '../../../../i18n';
import { navigate } from '../../../../utils/navigationService';
import routeUtils from '../../../../utils/routes';
import { useData } from './hooks';
import S from './styles';

const TopRatedListTitle = () => {
  const { isTopRatedEmpty, isFetching } = useData();

  const { t } = useTranslation();

  useOrientation();

  const onPressMoreTopRated = useCallback(
    () => navigate('TopRatedListPage'),
    []
  );

  if (isTopRatedEmpty) return null;

  return (
    <S.TitleSection width={GET_LAYOUT_MAX_WIDTH()}>
      <S.TitleText>{t('top-rated')}</S.TitleText>
      {!isFetching && (
        <S.MoreTopRated
          accessibilityRole="link"
          href={routeUtils.compileToPath('TopRatedListPage')}
          onPress={onPressMoreTopRated}
          hitSlop={{ top: 10, right: 10, bottom: 10, left: 10 }}
        ></S.MoreTopRated>
      )}
    </S.TitleSection>
  );
};

export default TopRatedListTitle;
